type SectionTitleType = {
    title: string
    children?: any
}
export default function SectionTitle({title, children}: SectionTitleType) {
    return (
        <div className="eo-sectionTitle">
            <h2 className="title">{title}</h2>
            {children}
        </div>
    )
}